module.exports = __webpack_public_path__ + "img/BT.4c7abd90.svg";